// @flow

import * as React from 'react';
import styled from 'styled-components';
import { Grid, Column, Row } from './Layout';
import { VERTICAL_SPACE } from '../utils/layout';
import { IsLargeScreen } from './Media';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  opacity: 0.75;
`;

const Box = styled.div`
  height: ${VERTICAL_SPACE}px;
  border: 1px solid #ccc;
`;

const howManyRows = () =>
  Math.floor(
    (document.body
      ? Math.max(document.body.scrollHeight, window.innerHeight)
      : window.innerHeight) / VERTICAL_SPACE
  );

export default class GridVisualizer extends React.Component<{}> {
  renderColumns(number: number) {
    const boxes = [];
    for (let x = 0; x < howManyRows(); x++) {
      boxes.push(<Box key={x} />);
    }

    const columns = [];
    for (let i = 0; i < number; i++) {
      columns.push(
        <Column key={i} small={2} medium={2} large={1}>
          {boxes}
        </Column>
      );
    }

    return columns;
  }

  render() {
    return (
      <IsLargeScreen>
        {(match) => {
          return (
            <Container>
              <Grid>
                <Row>
                  {match ? this.renderColumns(12) : this.renderColumns(6)}
                </Row>
              </Grid>
            </Container>
          );
        }}
      </IsLargeScreen>
    );
  }
}
